import axios from 'axios';
import Vue from 'vue';
import VueRouter from 'vue-router';

import resourceCard from './components/resource-card';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    /*
    We just add one route
     */
    routes: [
        { path: '/resources/:categories' }
    ]
});

new Vue({
    router,
    el: '#resources-app',
    components: {
        resourceCard
    },
    delimiters: ['${', '}'],
    data: {
        searchError: null,
        pagination: null,
        keywords: '',
        industries: [],
        categories: [],
        filters: [],
        results: [],
        pages: 1,
        queryParam: null,
    },
    computed: {
        resultMeta() {
            let pn = this.pagination;
            if (pn && pn.count > 0) {
                let start = (pn.current_page - 1) * pn.per_page + 1;
                let end   = start - 1 + pn.count;

                return 'Showing ' + start + ' to ' + end + ' of ' + pn.total + '.';
            }

            return '';
        },
        hasFetched() {
            return (this.results.length > 0 || this.searchError);
        },
        hasFilters() {
            return (this.filters.length > 0);
        },
        hasResults() {
            return (this.pagination && this.pagination.total > 0);
        },
        morePages() {
            return (this.pagination && this.pagination.current_page < this.pagination.total_pages);
        },
        loadMoreSlug() {
            return router.currentRoute.path + '/p' + (this.pages + 1);
        },
    },
    methods: {
        isActive(id) {
            return this.filters.includes(id);
        },
        toggleFilter(id) {
            if (this.isActive(id)) {
                let key = this.filters.indexOf(id);
                this.filters.splice(key, 1);
            } else {
                // Only 1 industry active at a time
                if (this.isIndustry(id)) {
                    this.clearIndustries();
                }
                this.filters.push(id);
            }

            this.pages = 1;
            this.fetchResources(true);
        },
        clearFilters() {
            this.filters = [];
            this.pages = 1;
            this.fetchResources(true);
        },
        isIndustry(id) {
            for (let i = 0; i < this.industries.length; i++) {
                if (id == this.industries[i].id) {
                    return true;
                }
            }

            return false;
        },
        clearIndustries() {
            for (let i = 0; i < this.industries.length; i++) {
                let id = this.industries[i].id;

                if (this.isActive(id)) {
                    let key = this.filters.indexOf(id);
                    this.filters.splice(key, 1);
                }
            }
        },
        composeUrl(slug=null) {
            let route = router.currentRoute.path;

            if (this.queryParam) {
                let urlSlug = '/' + this.parseSlug(this.queryParam);
                route = route.replace(urlSlug, '');
            }

            if (!slug) {
                return route;
            }
            return route + '/' + slug;
        },
        parseId(slug) {
            for (let i = 0; i < this.categories.length; i++) {
                if (this.categories[i].slug == slug) {
                    return this.categories[i].id;
                }
            }
            for (let i = 0; i < this.industries.length; i++) {
                if (this.industries[i].slug == slug) {
                    return this.industries[i].id;
                }
            }
            return null;
        },
        parseSlug(id) {
            for (let i = 0; i < this.categories.length; i++) {
                if (this.categories[i].id == id) {
                    return this.categories[i].slug;
                }
            }
            for (let i = 0; i < this.industries.length; i++) {
                if (this.industries[i].id == id) {
                    return this.industries[i].slug;
                }
            }
            return null;
        },
        updateFocus() {
            const focusIndex = (this.pages - 1) * 9
            if (this.$refs.resourceCards) {
                const cards = this.$refs.resourceCards.querySelectorAll('.resources__card')
                if ( focusIndex >= 9 ) {
                    cards[focusIndex].focus()
                }
            }
        },
        loadMore() {
            if (this.hasResults) {
                let pgs = this.pages + 1;

                this.pages =  (this.morePages) ? pgs : this.pagination.total_pages;
                this.fetchResources();
            } else {
                this.pages = 1;
            }
        },
        fetchResources(scrollToFilter = false) {

            this.searchError = null;

            if (this.keywords.length == 0 && this.filters.length == 0) {
                this.pagination = null;
                this.results = [];
                router.replace({ query: {}})
                    .catch(err => {});
                return;
            }

            let selectIndustries = this.filters.filter(id => this.isIndustry(id));

            let i = 0;
            let categories = [];

            for (i = 0; i < this.filters.length; i++) {
                if (selectIndustries.length > 0) {
                    if (selectIndustries[0] == this.filters[i]) {
                        continue;
                    }
                }

                categories.push(this.filters[i]);
            }

            let url = '/api/resources?keywords=' + encodeURI(this.keywords) + '&industries=' + JSON.stringify(selectIndustries) + '&categories=' + JSON.stringify(categories) + '&pages=' + this.pages;

            axios.get(url)
                .then(({data}) => {
                    if (data.meta.pagination.total) {
                        this.results = data.data;
                        this.pagination = data.meta.pagination;
                    } else {
                        if (data.meta.pagination.total == 0) {
                            this.searchError = 'Your search found results.';
                        }
                        this.pagination = null;
                        this.results = [];
                    }
                })
                .then(() => {
                    this.updateFocus()
                })

            this.setBrowserLocation();

            if (scrollToFilter) {
                let $root = $('html, body');
                let $filterTop = $('#filter-top');
                let $headerHeight = $( 'header.header.-primary').outerHeight()

                $root.animate(
                    {
                        scrollTop: $filterTop.offset().top - ( $headerHeight + 15 )
                    },
                    500
                );
            }
        },
        setBrowserLocation() {
            let route = this.composeUrl();
            let temp = [];

            if (this.filters.length) {
                this.filters.forEach(id => {

                    let slug = this.parseSlug(id);
                    temp.push(slug);
                });
            }

            let selectedCategories = temp.join(',');

            if (this.keywords.length && selectedCategories.length) {
                router.replace({path: route, query: {keywords: this.keywords, categories: selectedCategories}})
                    .catch(err => { console.log(err) });
            } else if (this.keywords.length) {
                router.replace({path: route, query: {keywords: this.keywords}})
                    .catch(err => { console.log(err) });
            } else if (selectedCategories.length) {
                router.replace({path: route, query: {categories: selectedCategories}})
                    .catch(err => { console.log(err) });
            } else {
                router.replace({path: route})
                    .catch(err => { console.log(err) });
            }
        },
        loadFilters() {
            let load = () => this.loadIndustryCategories()
                    .then(this.loadResourceCategories)
                    .then(this.setFilters);

            load();
        },
        loadIndustryCategories() {
            return axios.get('/api/categories/industry')
                .then(({data: {data}}) => {
                    if (data && data.length > 0) {
                        this.industries = data;
                    }
                });
        },
        loadResourceCategories() {
            return axios.get('/api/categories/resource')
                .then(({data: {data}}) => {
                    if (data && data.length > 0) {
                        this.categories = data;
                    }
                });
        },
        setFilters() {
            if (Object.entries(this.$route.query).length > 0 && this.$route.query.constructor === Object) {
                // Filters have been passed in the querystring. Set filters based on that data.
                let categories = this.$route.query.categories ? this.$route.query.categories.split(',') : [];

                for (let i = 0; i < categories.length; i++) {
                    let id = this.parseId(categories[i]);
                    if (!this.isActive(id)) {
                        this.filters.push(id);
                    }
                }

                this.keywords  = this.$route.query.keywords   ? this.$route.query.keywords : '';
            }

            if (this.keywords.length || this.filters.length) {
                this.fetchResources();
            }
        }
    },
    mounted() {
        this.loadFilters();
    },
});
